import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ImportTmsLoadResult, ImportTmsLoadType } from '../../../shared/tms-import/import-tms-load-result';

@Component({
  selector: 'app-tms-import-load-list-result',
  templateUrl: './tms-import-load-list-result.component.html',
  styleUrls: ['./tms-import-load-list-result.component.scss']
})
export class TmsImportLoadListResultComponent implements OnInit, OnChanges {

  @Input()
  successes: ImportTmsLoadResult[] = [];

  @Input()
  failures: ImportTmsLoadResult[] = [];

  @Input()
  type: ImportTmsLoadType;

  nbRows = 0;

  showSuccesses = false;
  showFailures  = false;

  ImportTmsLoadType = ImportTmsLoadType;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.countRows();
  }

  countRows() {
    let nbRows = 0;

    if (this.successes && this.successes.length > 0) {
      nbRows++;
    }

    if (this.failures && this.failures.length > 0) {
      nbRows++;
    }

    this.nbRows = nbRows;
  }

  toggleSuccesses() {
    this.showSuccesses = !this.showSuccesses;
  }

  toggleFailures() {
    this.showFailures = !this.showFailures;
  }

}
